import script from "./CardOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./CardOrder.vue?vue&type=script&setup=true&lang=js"

import "./CardOrder.vue?vue&type=style&index=0&id=01364ff8&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01364ff8"]])

export default __exports__